import { useState, useRef } from "react";
import { styles } from "../style";
import { FaPhone, FaEnvelope, FaAddressCard } from "react-icons/fa"
import emailjs from '@emailjs/browser'
import { toast } from "react-toastify";

const Contact = () => {
    const formRef = useRef();
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    })

    const { name, email, message } = formData;

    const [isLoading, setLoading] = useState(false)

    const handleChange = (e) => {
        setFormData((prevState) => ({
            ...prevState, [e.target.name]: e.target.value
        }))
    }
    const handleSubmit = (e) => {
        e.preventDefault()
        setLoading(true)

        emailjs.send('service_sxcjtc5',
            'template_k0cynn6',

            {
                from_name: name,
                to_name: 'David',
                from_email: email,
                to_email: 'damydavo2015@gmail.com',
                message: message
            },
            'GX7BCITNhetvACbNc'
        )
            .then(() => {
                setLoading(false)
                toast.success('Message sent successfully!')

                setFormData({
                    name: '',
                    email: '',
                    message: ''
                })

            }, (error) => {
                setLoading(false)
                toast.error('Something went wrong.')
            })
    }

    return (
        <div id="contact" className={`${styles.paddingX} mx-auto md:flex sm:gap-8 max-w-7xl xs:mt-4 md:mt-32 gap-24 pb-6 md:pb-0 font-poppins`}>

            <div className="flex flex-col">
                <h2 className="text-white font-semibold text-2xl">Please Kindly contact me for projects.</h2>
                <p className="mt-4 text-secondary text-lg underline"><a className="flex items-center gap-2" href="tel:+2348106048379"><FaPhone />+2348106048379</a></p>
                <p className="mt-4 text-secondary text-lg"><a className="flex items-center gap-2" href="mailto: damydavo2015@gmail.com"><FaEnvelope />damydavo2015@gmail.com</a></p>
                <p className="flex mt-4 text-secondary text-lg items-center  gap-2"><FaAddressCard />Balengi Avenue, Magboro Ogun State.</p>


            </div>


            <div className="bg-black-100 rounded-md mt-16 md:mt-0 md:py-4 px-4 w-100 flex items-center flex-col">
                <p className={`${styles.sectionHeadText} text-secondary`}>Get in touch</p>
                <form autoComplete="off" ref={formRef} onSubmit={handleSubmit} className='mt-4 flex flex-col gap-8 w-80 md:w-full p-2'>
                    <div className="flex flex-col md:flex-row gap-4">
                        <label className='flex flex-col'>
                            <span className='text-secondary font-medium mb-4'>Name</span>
                            <input
                                type='text'
                                name='name'
                                required
                                value={name}
                                onChange={handleChange}
                                placeholder="Please enter your name"
                                className='bg-tertiary py-4 px-6 placeholder:text-secondary text-white rounded-lg outline-none border-none font-medium'
                            />
                        </label>
                        <label className='flex flex-col'>
                            <span className='text-secondary font-medium mb-4'>Your email</span>
                            <input
                                type='email'
                                name='email'
                                required
                                onChange={handleChange}
                                value={email}
                                placeholder="Please enter your email"
                                className='bg-tertiary py-4 px-6 placeholder:text-secondary text-white rounded-lg outline-none border-none font-medium'
                            />
                        </label>
                    </div>

                    <label className='flex flex-col'>
                        <span className='text-secondary font-medium mb-4'>Your Message</span>
                        <textarea
                            rows={2}
                            name='message'
                            onChange={handleChange}
                            required
                            value={message}
                            placeholder='What you want to say?'
                            className='bg-tertiary py-4 px-6 placeholder:text-secondary text-white rounded-lg outline-none border-none font-medium'
                        />
                    </label>

                    <button type='submit' className='bg-tertiary py-4 md:py-3 px-8 rounded-xl outline-none w-fit text-white font-bold shadow-md'
                    >
                        {isLoading ? 'Sending...' : 'Send'}
                    </button>
                </form>

            </div>

        </div>
    );
}

export default Contact;